import SvgEllipse from "@Components/CustomIcon/SvgEllipseOrange"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { currentDiagnosisAtom, educationalDiagnosisVisioAtom } from "@Recoil/Atom/DiagnosisAtom"
import { dbDateTimeFormat, localDateFormat } from "@Utils/utils"
import moment from "moment"
import React, { useEffect } from "react"
import { StyleSheet, TouchableOpacity, View, ViewBase } from "react-native"
import { useRecoilValue } from "recoil"

export const VideoRDVCard = (props) => {
    const { disabled } = props
    const currentEducationalDiagnosis = useRecoilValue(currentDiagnosisAtom)
    const startDate = currentEducationalDiagnosis?.visioconferenceEvent?.startDate ?? new Date()

    const videoPointDate = currentEducationalDiagnosis?.visioconferenceEvent?.startDate
        ? moment(startDate, dbDateTimeFormat).format(localDateFormat + " à HH:mm")
        : null
    const rdvState =
        currentEducationalDiagnosis?.visioconferenceEvent?.id > 0 ? `Planifié le ${videoPointDate}` : "Non planifié"
    const rdvTextColor = disabled ? baseColors.grey : "white"

    return (
        <TouchableOpacity disabled={disabled} activeOpacity={0.7} onPress={props.onPress}>
            <View
                style={{
                    borderRadius: 10,
                    overflow: "hidden",
                    height: 101,
                    width: "100%",
                    marginVertical: 8,
                    backgroundColor: props.backgroundColor
                }}
            >
                <BreeSerifText style={{ marginHorizontal: 15, marginTop: 15 }} fontSize={20} color={rdvTextColor}>
                    {props.title}
                </BreeSerifText>

                <OpenSansText fontSize={14} style={{ marginHorizontal: 15, marginTop: 10 }} color={rdvTextColor}>
                    {rdvState}
                </OpenSansText>

                <View style={{ position: "absolute", alignSelf: "flex-end" }}>
                    <SvgEllipse height={101} width={100} fill={props.ellipseColor}></SvgEllipse>
                    {props.svgIcon}
                </View>
            </View>
        </TouchableOpacity>
    )
}

const style = StyleSheet.create({
    container: {
        borderRadius: 10,
        overflow: "hidden",
        height: 101,
        width: "100%",
        marginVertical: 8
    }
})
